import { EventType } from '../../../../App.types'

import { DiscoverPath } from './Discover.types'

export const DISCOVER_PATH_TRANSLATION_MAPPING: Record<
  DiscoverPath,
  | 'camps'
  | 'classes-and-trainings'
  | 'courses'
  | 'education'
  | 'workshops'
  | 'events'
  | 'retreats'
  | 'open-trainings'
  | 'public-matches'
> = {
  [DiscoverPath.CAMPS]: 'camps',
  [DiscoverPath.CLASSES]: 'classes-and-trainings',
  [DiscoverPath.COURSES]: 'courses',
  [DiscoverPath.EDUCATION]: 'education',
  [DiscoverPath.EVENTS]: 'events',
  [DiscoverPath.RETREATS]: 'retreats',
  [DiscoverPath.OPEN_TRAININGS]: 'open-trainings',
  [DiscoverPath.PUBLIC_MATCHES]: 'public-matches',
  [DiscoverPath.WORKSHOPS]: 'workshops',
}

export const EVENT_LIMIT = 18
export const EVENT_TYPES = [EventType.CLASS, EventType.TRAINING]
